export default __webpack_public_path__ + "static/media/slides_informed_search.8b3854aa.pdf";